import { render, staticRenderFns } from "./BillingForm.vue?vue&type=template&id=52ee29b5&scoped=true"
import script from "./BillingForm.vue?vue&type=script&lang=js"
export * from "./BillingForm.vue?vue&type=script&lang=js"
import style0 from "./BillingForm.vue?vue&type=style&index=0&id=52ee29b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee29b5",
  null
  
)

export default component.exports